dmx.Component('pdf-header', {

  attributes: {
    columnGap: {
      type: Number,
      default: 10,
    },

    margin: {
      type: [Number, Array],
      default: 10,
      ui: {
        groupTitle: 'Margin',
        arrayVariables: true,
        isDynamic: true,
        variables: [
          {name: 'marginLeft', type: 'text', title: 'Left', dataBindings: true, arrayIndex:0, defaultValue: 10},
          {name: 'marginTop', type: 'text', title: 'Top', dataBindings: true, arrayIndex:1, defaultValue: 10},
          {name: 'marginRight', type: 'text', title: 'Right', dataBindings: true, arrayIndex:2, defaultValue: 10},
          {name: 'marginBottom', type: 'text', title: 'Bottom', dataBindings: true, arrayIndex:3, defaultValue: 10},
        ]
      },
    },
  },

  ui: {
    tagName: 'dmx-pdf-header',
    children: ['dmx-pdf-text', 'dmx-pdf-image'],
    allowed_children: {'dmx-pdf-text':-1, 'dmx-pdf-image':-1},
    allowedGlobalChildren: {}
  },

  render (node) {
    node.style.display = 'none';
    this.$parse();
  },

  _getAbsoluteUrl (url) {
    const a = document.createElement('a');
    a.href = url;
    return a.href;
  },

  _createHeader () {
    const ret = {
      header: {
        columns: [],
        ...this.props,
      },
      images: {},
    };

    for (const child of this.children) {
      if (child.data.$type === 'pdf-image') {
        const ref = 'img_ref_' + Math.random().toString(36).slice(2,8);
        const url = this._getAbsoluteUrl(child.props.src);
        const props = {};
        
        if (child.props.fit) {
          props.fit = [child.props.width || 1000, child.props.height || 1000];
          if (child.props.width) props.width = child.props.width;
        } else {
          if (child.props.width) props.width = child.props.width;
          if (child.props.height) props.height = child.props.height;
        }

        ret.images[ref] = url;
        ret.header.columns.push({
          image: ref,
          ...props
        });

        continue;
      }

      ret.header.columns.push({ ...child.props });
    }

    return {
      header: (currentPage, pageCount) => {
        const header = structuredClone(ret.header);

        for (const col of header.columns) {
          if (col.text) col.text = col.text.replace(/##page##/g, currentPage).replace(/##total##/g, pageCount);
        }
        
        //console.info('pdf-header', header);

        return header;
      },
      images: ret.images,
    };
  },

});